import type { ScriptLine } from "../../coldcompute";

// Caption lines are SCENE-LOCAL (fromSec resets to 0 inside each scene's <Sequence>).
// VO == on-screen caption. Every claim is grounded in EAKC-MVP:
//   hybrid_search_document_chunks vector pass — a CASE preference expression placed
//     BEFORE `embedding <=> query` in the ORDER BY (the trap)
//   Postgres statement_timeout = 8s; the killed query: `canceling statement due to
//     statement timeout` / code 57014 (was logged as a useless `[object Object]`)
//   pgvector HNSW accelerates ONLY a pure `ORDER BY embedding <=> query LIMIT k`;
//     a leading expression → sequential scan over ALL ~24,837 source vectors
//   measured: 6,013 ms → 701 ms after fetching nearest-K pure, then re-sorting outside
// No fabricated numbers — the 6013/701 latencies, the 8s timeout, the 57014 code, and
// the ~24,837-vector source count are the real figures from the incident.

export const HOOK: ScriptLine[] = [
  { scene: "hook", fromSec: 0.3, holdSec: 5.0, caption: "EAKC chat answers started timing out — and the only clue in the logs was a useless [object Object]." },
];

export const REVEAL: ScriptLine[] = [
  { scene: "reveal", fromSec: 0.3, holdSec: 5.5, caption: "Once I logged the error properly, it read: canceling statement due to statement timeout — code 57014." },
  { scene: "reveal", fromSec: 6, holdSec: 5.5, caption: "The hybrid search query was taking about six seconds, so Postgres killed it at the 8-second limit." },
  { scene: "reveal", fromSec: 12, holdSec: 5.0, caption: "A retrieval query that should take milliseconds was burning six full seconds. Something was doing way too much work." },
];

export const DIAGNOSIS: ScriptLine[] = [
  { scene: "diagnosis", fromSec: 0.3, holdSec: 6, caption: "The culprit was one line in the vector pass of hybrid_search_document_chunks." },
  { scene: "diagnosis", fromSec: 6.5, holdSec: 6.5, caption: "It ordered by a CASE preference expression FIRST, and only then by the distance operator." },
  { scene: "diagnosis", fromSec: 13.5, holdSec: 5.5, caption: "That tiny reorder — the CASE before the <=> — is the whole bug." },
];

export const TRAP: ScriptLine[] = [
  { scene: "trap", fromSec: 0.3, holdSec: 6, caption: "Here's the trap: pgvector's HNSW index can only accelerate a PURE order-by-distance, limit-k query." },
  { scene: "trap", fromSec: 6.5, holdSec: 6.5, caption: "Put any expression before the distance operator and Postgres abandons the index entirely." },
  { scene: "trap", fromSec: 13.5, holdSec: 6, caption: "It falls back to a sequential scan: exact cosine distance across all ~24,837 vectors, then a full sort. Six seconds." },
];

export const CODE: ScriptLine[] = [
  { scene: "code", fromSec: 0.3, holdSec: 6.5, caption: "The fix keeps the index happy: fetch the nearest K in a pure-distance subquery so HNSW kicks in." },
  { scene: "code", fromSec: 7, holdSec: 7, caption: "Then apply the preference re-sort and the similarity threshold in an OUTER query — over a tiny candidate set." },
  { scene: "code", fromSec: 14.5, holdSec: 8.5, caption: "Same result, same ranking. The expensive work just never touches all 24,837 rows again." },
];

export const PAYOFF: ScriptLine[] = [
  { scene: "payoff", fromSec: 0.3, holdSec: 5.5, caption: "Six thousand and thirteen milliseconds down to seven hundred and one. About eight and a half times faster." },
  { scene: "payoff", fromSec: 6, holdSec: 5.5, caption: "The timeout was gone, and BM25 hybrid retrieval was back — from one line of SQL." },
];

export const LESSON: ScriptLine[] = [
  { scene: "lesson", fromSec: 0.3, holdSec: 5.5, caption: "The lesson: never put an expression before the distance operator in an ORDER BY you want the vector index to serve." },
];

export const OUTRO: ScriptLine[] = [
  { scene: "outro", fromSec: 0.3, holdSec: 5, caption: "Fetch nearest-K pure, then re-sort. Keep the index on the hot path." },
  { scene: "outro", fromSec: 5.5, holdSec: 3.8, caption: "That's the series — it's all open: the repo, the migrations, the dashboard. Build in public, break in production." },
];

;
    var _remotion_globalVariableA;
    var _remotion_globalVariableB;
    // Legacy CSS implementations will `eval` browser code in a Node.js context
    // to extract CSS. For backwards compatibility, we need to check we're in a
    // browser context before continuing.
    if (typeof self !== 'undefined' &&
        // AMP / No-JS mode does not inject these helpers:
        '$RefreshHelpers$' in self) {
        const currentExports = __webpack_module__.exports;
        const prevExports = (_remotion_globalVariableB = (_remotion_globalVariableA = __webpack_module__.hot.data) === null || _remotion_globalVariableA === void 0 ? void 0 : _remotion_globalVariableA.prevExports) !== null && _remotion_globalVariableB !== void 0 ? _remotion_globalVariableB : null;
        // This cannot happen in MainTemplate because the exports mismatch between
        // templating and execution.
        self.$RefreshHelpers$.registerExportsForReactRefresh(currentExports, __webpack_module__.id);
        // A module can be accepted automatically based on its exports, e.g. when
        // it is a Refresh Boundary.
        if (self.$RefreshHelpers$.isReactRefreshBoundary(currentExports)) {
            // Save the previous exports on update so we can compare the boundary
            // signatures.
            __webpack_module__.hot.dispose((data) => {
                data.prevExports = currentExports;
            });
            // Unconditionally accept an update to this module, we'll check if it's
            // still a Refresh Boundary later.
            __webpack_module__.hot.accept();
            // This field is set when the previous version of this module was a
            // Refresh Boundary, letting us know we need to check for invalidation or
            // enqueue an update.
            if (prevExports !== null) {
                // A boundary can become ineligible if its exports are incompatible
                // with the previous exports.
                //
                // For example, if you add/remove/change exports, we'll want to
                // re-execute the importing modules, and force those components to
                // re-render. Similarly, if you convert a class component to a
                // function, we want to invalidate the boundary.
                if (self.$RefreshHelpers$.shouldInvalidateReactRefreshBoundary(prevExports, currentExports)) {
                    __webpack_module__.hot.invalidate();
                }
                else {
                    self.$RefreshHelpers$.scheduleUpdate();
                }
            }
        }
        else {
            // Since we just executed the code for the module, it's possible that the
            // new exports made it ineligible for being a boundary.
            // We only care about the case when we were _previously_ a boundary,
            // because we already accepted this update (accidental side effect).
            const isNoLongerABoundary = prevExports !== null;
            if (isNoLongerABoundary) {
                __webpack_module__.hot.invalidate();
            }
        }
    }
